import styled from 'styled-components';

export default styled.span`
  position: absolute;
  top: 0;
  left: 0;
  height: 1rem;
  width: 1rem;
  background-color: ${({ theme }) => theme.grayLightColor};
  border-radius: 50%;
`;
